import React from 'react';

import {Box, Stack, Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';

const {
	descriptionPart1,
	descriptionPart2,
	descriptionPart3,
	descriptionPart4,
	descriptionPart5,
	descriptionPart6,
	descriptionPart7,
	descriptionPart8,
	descriptionPart9,
	descriptionPart10,
} = translations['pt-br'].privateFlow.myAppointments.myAppointmentsList.surgeryOrientations;

export function OrientationsTexts() {
	return (
		<Stack gap={2}>
			<Typography>{descriptionPart1}</Typography>
			<Box component="ul" sx={{listStyleType: 'disc', pl: 2}}>
				<Typography component="li">{descriptionPart2}</Typography>
				<Typography component="li">{descriptionPart3}</Typography>
				<Typography component="li">{descriptionPart4}</Typography>
				<Typography component="li">{descriptionPart5}</Typography>
				<Typography component="li">{descriptionPart6}</Typography>
				<Typography component="li">{descriptionPart7}</Typography>
				<Typography component="li">{descriptionPart8}</Typography>
			</Box>
			<Typography>{descriptionPart9}</Typography>
			<Typography fontWeight={600}>{descriptionPart10}</Typography>
		</Stack>
	);
}
